import React from 'react';
import { motion } from 'framer-motion';
import classNames from 'classnames';
import WarningIcon from 'wb-reddit/assets/warning.svg';
import { useNavigate } from 'react-router-dom';
import { Button } from '@aleph/shared-components';
import { useTranslation } from 'react-i18next';

const NotFound = () => {
	const navigate = useNavigate();
	const { t } = useTranslation();

	return (
		<div
			className="top-0 left-0 absolute w-full h-full bg-backdrop-gradient
		backdrop-blur-[6px] flex items-center justify-center z-[1002]"
		>
			<motion.div
				initial={{ opacity: 0 }}
				animate={{ opacity: 1 }}
				exit={{ opacity: 0 }}
				transition={{ duration: 0.15 }}
				style={{ maxWidth: 561 }}
				className={
					classNames(
						'max-h-[800px] bg-white flex flex-col',
						'[@media(max-height:800px)]:max-h-[100vh]',
					)}
			>
				<div
					className="flex items-center justify-center"
					style={{ marginBottom: 32 }}
				>
					<img
						src={WarningIcon}
						width="313"
						alt=''
					/>
				</div>
				<div
					className="flex items-center justify-center"
					style={{ marginBottom: 16 }}
				>
					<h3 style={{
						fontSize:   24,
						fontWeight: 700,
						color:      '#050B14',
					}}
					>
						{t('sc: 404.title', 'Page not found')}
					</h3>
				</div>
				<div
					className="flex items-center justify-center"
					style={{
						fontSize:     18,
						fontWeight:   400,
						marginBottom: 32,
						textAlign:    'center',
					}}
				>
					{t('sc: 404.body', `It might have been moved, deleted, or the URL is incorrect.
						Please check the URL for typos or go back.`)}
				</div>
				<div className="flex items-center justify-center">
					<Button
						title={t('sc: back_to_home', 'Back to home')}
						size="large"
						onClick={() => navigate('/')}
					/>
				</div>
			</motion.div>
		</div>
	);
};

export default NotFound;
